import { actionCreatorFactory } from 'typescript-fsa';
import { ApiFieldError } from 'src/types';
import { LoanDocuments } from 'src/types/DocumentPointer';
import { SiteSettings } from 'src/types/SiteSettings';

type APIError = ApiFieldError;

export type UpdateSiteSettingsPayload = Partial<SiteSettings>;

export type UpdateSiteSettingsParams = UpdateSiteSettingsPayload;

/**
 * Action Creators
 */
export const actionCreator = actionCreatorFactory(`@@manager/siteSettings`);

export const siteSettingsRequest = actionCreator('request');

export const siteSettingsRequestSuccess =
  actionCreator<LoanDocuments>('success');

export const siteSettingsRequestFail = actionCreator<ApiFieldError[]>('fail');

export const updateSiteSettingsActions = actionCreator.async<
  UpdateSiteSettingsParams,
  SiteSettings,
  APIError[]
>(`update`);
